import { useContext, useEffect, useState, useRef } from "react"
import { AppContext } from "../App"
import { AiOutlineUser } from 'react-icons/ai';
import { callApi, CDN_URL, formatDate, formatMoney, getInlineLoader } from "../Helpers";
import {
	STR_AGENT_REPORT,
	STR_AMOUNT_2,
	STR_AVAILABLE_HOTELS,
	STR_BACK,
	STR_CASH,
	STR_CHANGE_PHONE_NUMBER,
	STR_CLOSE_REQUEST,
	STR_CLOSING_BALANCE,
	STR_COMMISSIONS_REPORT,
	STR_CONSULTATION_FEE_PAYMENTS,
	STR_CONTACT_US,
	STR_COULD_NOT_FETCH_DATA,
	STR_DESCRIPTON,
	STR_DISTRICT,
	STR_FLOAT,
	STR_INVALID_SERVICE_PROVIDER,
	STR_MENU_HOTELS,
	STR_NO_RECORD,
	STR_NORMAL_AGENT,
	STR_NOTIFICATIONS,
	STR_OPENING_BALANCE,
	STR_PAYABLE,
	STR_PAYMENT_SETTINGS,
	STR_PERSONAL_SETTINGS,
	STR_PHOTO_EVIDENCE,
	STR_RECEIVABLE,
	STR_RECENT_REQUESTS,
	STR_REGION,
	STR_REQUEST_AMOUNT_LIMIT,
	STR_REQUEST_FLOAT,
	STR_REQUEST_FLOAT_CASH,
	STR_SELECT,
	STR_SELECT_2,
	STR_SELECT_REQUEST_TYPE,
	STR_SEND_MESSAGE_TO_AGENT,
	STR_SERVICE_PROVIDER,
	STR_STREET,
	STR_SUB_TOTAL,
	STR_SUBMIT,
	STR_SUBSCRIPTION_FEE_PAYMENTS,
	STR_SUCCESS,
	STR_SUPER_AGENT,
	STR_TILL_NUMBER,
	STR_TILL_NUMBERS,
	STR_TOTAL_2,
	STR_UPDATE_PERSONAL_INFO,
	STR_UPDATE_USERNAME,
	STR_VIEW_AGENT_PROFILE,
	STR_WARD,
	STR_YOUR_REQUEST
} from "../Strings";
import { BsFillPersonLinesFill, BsPersonGear } from 'react-icons/bs';
import { MdCheckCircle, MdContactPage, MdInfoOutline, MdLocationPin, MdMessage, MdOutlinePayment, MdOutlinePayments, MdOutlinePhonelinkSetup, MdOutlineSupport, MdSupportAgent, MdTranslate } from 'react-icons/md';
import { CgProfile } from "react-icons/cg";
import login_bg from '../assets/login_bg.jpg';
import HomeMenu from "./HomeMenu";
import WelcomeSlider from '../ones/WelcomeSlider';
import EditAgentProfile from "./EditAgentProfile";
import OpSuccessWidget from "../ones/OpSuccessWidget";
import { FaMoneyBillTransfer, FaMoneyBillTrendUp, FaUserTag } from "react-icons/fa6";
import { IoPersonSharp } from "react-icons/io5";
import { RiMessage2Line } from "react-icons/ri";

export default function View({ id }) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [loading, setLoading] = useState(false);
	const [agentReportData, setAgentReportData] = useState(null);
	
	async function init() {
		//run initializations here
		setReady(false);
		//..
		await Promise.all([
			getAgentReportData(),
		])
		setReady(true);
	}

	async function getAgentReportData() {
		await callApi('get-agent-report-data', { id }).then((response) => {
			if(response.status === 1) {
				setAgentReportData(response.data);
			} else {
				appContext.tellError(STR_COULD_NOT_FETCH_DATA[appContext.language]);
			}
		})
	} 

	
	useEffect(() => {
		init();
	}, [ id ])

	useEffect(() => {
		appContext.setShowOverlayLoader(loading);

		return () => {
			appContext.setShowOverlayLoader(false);
		}
	}, [ loading ])

	


	if (ready && agentReportData) {
		return (
			<div
				style={{
					width: "100%",
					height: "100%",
					overflow: "scroll",
					paddingBottom: "calc(var(--topBarHeight) + 40px)",
				}}
				className="mNoScrollBar"
			>
				<div className="container">
					<div className="row">
						<div className="col-md-12">
							<h6 className="mSectionTitle">{STR_AGENT_REPORT[appContext.language]}</h6>

							<h6
								className="font-semi-bold text-secondary text-end mt-4"
								style={{
									fontSize: "14px"
								}}
							>
								{formatDate(agentReportData.dateReported)}
							</h6>
						</div>

						<div className="col-md-12">
							<div className="card">
								<div className="card-body">
									<h6
										style={{
											fontSize: "28px"
										}}
										className="font-semi-bold"
									>
										<span style={{fontSize: "12px"}} className="badge bg-secondary">{STR_TOTAL_2[appContext.language]}</span>
										<br/>
										{formatMoney(agentReportData.totalAmount)} 
										<span style={{ fontSize: "18px" }}> TZS</span>
									</h6>

								
								</div>
							</div>
						</div>

						<div className="col-md-12">
							<div className="card">
								<div className="card-body">
									<h6 className="card-title">{STR_CLOSING_BALANCE[appContext.language]}</h6>
									
									{
										JSON.parse(agentReportData.reportBody1).map((item, i) => {
											
											return (
												<div 
													className=""
													key={i}
												>
													<h6
														className="font-semi-bold"
														style={{
															fontSize: "14px"
														}}
													>
														{
															(item.tillType === 'cash') ? STR_CASH[appContext.language] : appContext.getTillTypeName(item.tillType)
														}
														<br/>
														<span className="text-muted">{item.tillNumber}</span>
													</h6>

													<div className="text-end">
														<h6
															style={{
																fontSize: "18px"
															}}
														>
															TZS {formatMoney(item.amount)}
														</h6>
													</div>
													<hr/>
												</div>
											)
												
											
										})
									}

									<h6 
										className="font-semi-bold"
										style={{
											fontSize: "18px"
										}}
									>
										<span className="d-block font-semi-bold" style={{ fontSize: "14px" }} >{STR_SUB_TOTAL[appContext.language]}</span>
										{formatMoney(agentReportData.totalAmount1)} TZS
									</h6>
									
								</div>
							</div>
						</div>

						<div className="col-md-12">
							<div className="card">
								<div className="card-body">
									<h6 className="card-title">{STR_COMMISSIONS_REPORT[appContext.language]}</h6>
									
									{
										JSON.parse(agentReportData.reportBody2).map((item, i) => {
											
											return (
												<div 
													className=""
													key={i}
												>
													<h6
														className="font-semi-bold"
														style={{
															fontSize: "14px"
														}}
													>
														{
															(item.tillType === 'cash') ? STR_CASH[appContext.language] : appContext.getTillTypeName(item.tillType)
														}
														<br/>
														<span className="text-muted">{item.tillNumber}</span>
													</h6>

													<div className="text-end">
														<h6
															style={{
																fontSize: "18px"
															}}
														>
															TZS {formatMoney(item.amount)}
														</h6>
													</div>
													<hr/>
												</div>
											)
												
											
										})
									}
									
									<h6 
										className="font-semi-bold"
										style={{
											fontSize: "18px"
										}}
									>
										<span className="d-block font-semi-bold" style={{ fontSize: "14px" }} >{STR_SUB_TOTAL[appContext.language]}</span>
										{formatMoney(agentReportData.totalAmount2)} TZS
									</h6>

								</div>
							</div>
						</div>

						<div className="col-md-12">
							<div className="card">
								<div className="card-body">
									<h6 className="card-title">{STR_RECEIVABLE[appContext.language]}</h6>
									
									{
										JSON.parse(agentReportData.reportBody3).map((item, i) => {
												
											return (
												<div 
													className=""
													key={i}
												>
													<h6
														className="font-semi-bold"
														style={{
															fontSize: "14px"
														}}
													>
														{item.name}
													</h6>

													<div className="text-end">
														<h6
															style={{
																fontSize: "18px"
															}}
														>
															TZS {formatMoney(item.amount)}
														</h6>
													</div>
													<hr/>
												</div>
											)
												
											
										})
									}

									<h6 
										className="font-semi-bold"
										style={{
											fontSize: "18px"
										}}
									>
										<span className="d-block font-semi-bold" style={{ fontSize: "14px" }} >{STR_SUB_TOTAL[appContext.language]}</span>
										{formatMoney(agentReportData.totalAmount3)} TZS
									</h6>
									
								</div>
							</div>
						</div>

						<div className="col-md-12">
							<div className="card">
								<div className="card-body">
									<h6 className="card-title">{STR_PAYABLE[appContext.language]}</h6>
									
									{
										JSON.parse(agentReportData.reportBody4).map((item, i) => {
											
											return (
												<div 
													className=""
													key={i}
												>
													<h6
														className="font-semi-bold"
														style={{
															fontSize: "14px"
														}}
													>
														{
															(item.tillType === 'cash') ? STR_CASH[appContext.language] : appContext.getTillTypeName(item.tillType)
														}
														<br/>
														<span className="text-muted">{item.tillNumber}</span>
													</h6>

													<div className="text-end">
														<h6
															style={{
																fontSize: "18px"
															}}
														>
															TZS {formatMoney(item.amount)}
														</h6>
													</div>
													<hr/>
												</div>
											)
												
										})
									}

									<h6 
										className="font-semi-bold"
										style={{
											fontSize: "18px"
										}}
									>
										<span className="d-block font-semi-bold" style={{ fontSize: "14px" }} >{STR_SUB_TOTAL[appContext.language]}</span>
										{formatMoney(agentReportData.totalAmount4)} TZS
									</h6>
									
								</div>
							</div>
						</div>

						<div className="col-md-12">

							<div className="mt-4 mb-4">
								<label className="form-label">{STR_DESCRIPTON[appContext.language]}</label>
								<h6
									style={{
										fontSize: "16px"
									}}
								>
									{agentReportData.description || 'N/A'}
								</h6>
							</div>


							<div className="mt-4 mb-4">
								<label className="form-label">{STR_PHOTO_EVIDENCE[appContext.language]}</label>
								
								{
									(agentReportData.photo1 || agentReportData.photo2 || agentReportData.photo3) ?
									<>
										{
											(agentReportData.photo1) ?
											<img
												src={CDN_URL+agentReportData.photo1}
												style={{
													width: "100%",
													display: "block",
													borderRadius: "20px",
													height: "auto",
												}}
												className="mt-2 mb-2"
											/>
											:""
										}

										{
											(agentReportData.photo2) ?
											<img
												src={CDN_URL+agentReportData.photo2}
												style={{
													width: "100%",
													display: "block",
													borderRadius: "20px",
													height: "auto",
												}}
												className="mt-2 mb-2"
											/>
											:""
										}

										{
											(agentReportData.photo3) ?
											<img
												src={CDN_URL+agentReportData.photo3}
												style={{
													width: "100%",
													display: "block",
													borderRadius: "20px",
													height: "auto",
												}}
												className="mt-2 mb-2"
											/>
											:""
										}
									</>
									:
									<h6
										style={{
											fontSize: "16px"
										}}
									>
										{STR_NO_RECORD[appContext.language]}
									</h6>
								}
							</div>

							
						</div>
						
					</div>
				</div>


			</div>
		)
		
	} else {
		return (
			<div
				className="mSupportLoading"
				style={{
					width: "100%",
					height: "100%",
				}}
			>
				{getInlineLoader()}
			</div>
		);
	}


}